import {Component, Input} from "@angular/core";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {Notification} from "../../../shared/components/notifier/notification";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {NotificationType} from "../../../shared/components/notifier/notification-type";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserService} from '../../../user/user.service';
import {PaymentMethod} from "../../../user/payment-method";
import {WorkspaceService} from "../../workspace.service";
import {UserSubscription} from "../../../user/user-subscription";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import { filter, first } from "rxjs";

@Component({
    selector: 'db-remove-payment-method',
    templateUrl: './remove-payment-method.component.html',
    styleUrls: ['./remove-payment-method.component.scss'],
    standalone: false
})
export class RemovePaymentMethodComponent extends DialogComponent<null, boolean> {
  public loading: boolean;

  public title: string;
  public changes: any;
  @Input() paymentMethod: PaymentMethod;
  @Input() userSubscription?: UserSubscription;

  constructor(
    private _userService: UserService,
    private _workspaceService: WorkspaceService,
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    super(
      _dialogService
    );
  }

  public deletePaymentMethod(paymentMethodId): void {
    this.loading = true;
    this._workspaceService.removePaymentMethod(paymentMethodId)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response): void => {
        this.loading = false;
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserPaymentMethods());
          this.result = true;
          this.close();
          NotifierComponent.notify(new Notification("Payment method removed.", NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  public close_window(): void {
    this.close();
  }

}
